import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0681f024")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "column",
    param: _ctx.param,
    sortable: _ctx.sortable,
    style: _ctx.param && _ctx.sortable ? 'cursor: pointer' : ''
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 12, ["param", "sortable"]))
})